import { trackClickedButton } from "utils/analytics";
import { sidebarGradeValue } from "hooks/useSidebarTracking";

// Every picker event carries the page and the class; set events add the key.
export const PAGE_NAME = "Warm-Up Challenges";

const eventProps = (classroomId) => ({ page_name: PAGE_NAME, class: classroomId });

// "Back to Groups" and "Grade Filter" are the sidebar's existing values, reused
// (and its grade format: "All Grades", "K", "3" ... "12").
export const trackBackToGroups = (classroomId) => trackClickedButton("Back to Groups", eventProps(classroomId));

export const trackGradeFilter = (classroomId, gradeValue) =>
  trackClickedButton("Grade Filter", { ...eventProps(classroomId), grade: sidebarGradeValue(gradeValue) });

const setEventProps = (classroomId, set) => ({ ...eventProps(classroomId), warmup_set: set.key });

export const trackWarmUpSetOpened = (classroomId, set) =>
  trackClickedButton("Warm-Up Set", setEventProps(classroomId, set));

export const trackSetSelected = (classroomId, set) =>
  trackClickedButton("Select This Set", setEventProps(classroomId, set));

export const trackWarmUpGroupsSaved = (classroomId, set, { groupCount, sessionLength }) =>
  trackClickedButton("Save Warm-Up Groups", {
    ...setEventProps(classroomId, set),
    group_count: groupCount,
    session_length: sessionLength,
  });
